import React from 'react';
import { connect } from 'react-redux'
import { hashHistory } from 'react-router';
import Header from '../Components/Header/HeaderSmall';
import { changeTab } from '../actions/environmentActions';
import CareTypeDrillDown from '../Components/CareTypeDrillDown';
import SearchInput, {createFilter} from 'react-search-input'
import Paper from 'material-ui/Paper';
import { resourceApi } from '../utils/fetchUtil';
import ClickMe from 'material-ui/svg-icons/navigation/chevron-right';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import CircularProgress from 'material-ui/CircularProgress';
import TabStrip  from '../Components/TabStrip';
import { logUserSearch } from '../actions/logActions';

class SearchPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
        dataSource: [],
        categories: [],
        isFetching: false,
        searchTerm: ''
    };
  }

  componentDidMount() {
      this.props.updateTab();
      this.loadCategories();
      this.loadSearchList();
  }

  loadCategories = () => {

    var self = this;

    self.setState({ isFetching: true });

    let config = {
        method: 'get',
        url: `shop/categories`
    };

    resourceApi(config)
    .then(function (response) {
        self.setState({ categories: response.data, isFetching: false });
    })
    .catch(function (error) {
        console.log(error);
        self.setState({ isFetching: false });
    });
  }

 
  loadSearchList = () => {

      var self = this;

      self.setState({isFetching: true});

      
      let config = {
          method: 'get',
          url: `shop/searchlist`
      };

      resourceApi(config)
      .then(function (response) {
          self.setState({ dataSource: response.data });
          self.setState({isFetching: false});
      })
      .catch(function (error) {
          console.log(error);
          self.setState({isFetching: false});
      });
      
  }

  search(sctp){
    var item = this.state.dataSource.filter((el) =>
        el.ShoppableCPTCodeID == sctp
    );

    var term = this.state.searchText;
    if(item.length > 0) {
        term = item[0].FriendlyDescription;
    }

    this.props.logUserSearch(term, sctp);

    //selectProcedure = (sctp, name) => {
        localStorage.setItem('term', term);
        hashHistory.push(`search/${sctp}`);
    //}
}

  searchUpdated = (term) => {
    this.setState({searchTerm: term})
  }

  getPageTitle = () => {
    
    var moduleMatch = this.props.member.Modules.filter((m) => {
        return m.ApplicationModuleID === 1
    })
    
    if(moduleMatch.length > 0){
        return moduleMatch[0].Name;
    }
    else{
        return "Search For Care";
    }
    
  }

  render() {

    var filteredData = [];
    var self = this;
    this.state.dataSource.forEach(function(person){

        var pushed = false;

        var terms = self.state.searchTerm.split(' ');
        var qtySatisfied = 0;
        for(var i = 0; i < terms.length; i++) {
           if(person.FriendlyDescription.toLowerCase().indexOf(terms[i].toLowerCase()) >= 0) {
                qtySatisfied++;    
            }
        }

        if(qtySatisfied == terms.length) {
            filteredData.push(person);
        }
    });

    const {isFetching} = this.state;


    return (
         <div>
           <Header title={this.getPageTitle()}>
            </Header>
            <div className="container trueno" >
                {isFetching && (
                   <div className="centered" >
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                        <CircularProgress /> 
                    </div>
                )}

                {!isFetching && (
                  <div>
                        <Paper zDepth={1} >
                             <div style={{padding: "15px 0 0 15px" }}>
                                <h4>Search For A Procedure</h4>
                            </div>
                            <SearchInput id="das" className="search-input"  onChange={this.searchUpdated} placeholder="Type to search" />
                        </Paper>
                        <br />
                       {(this.state.searchTerm === "") && (
                           <Paper zDepth={1} >
                                <div style={{padding: "15px 0 0 15px" }}>
                                    <h4>Search By Category</h4>
                                </div>
                                <CareTypeDrillDown categories={this.state.categories}/>
                            </Paper>
                       )}

                       {(this.state.searchTerm !== "") && (

                            <Paper zDepth={1} >
                                <List>
                                    {(filteredData.length > 0) && filteredData.map((item, index) => {
                                        return (
                                            <div>
                                                <ListItem
                                                key={item.ShoppableCPTCodeID}
                                                primaryText={item.FriendlyDescription} 
                                                className="trueno"
                                                onClick={() => this.search(item.ShoppableCPTCodeID)}
                                                rightIcon={<ClickMe />}
                                                />
                                                {((index + 1) !== filteredData.length) && (
                                                    <Divider />
                                                )}
                                                
                                            </div>
                                            )
                                        }
                                    )}

                                    {(filteredData.length == 0) && (
                                        <div style={{padding: "15px 0 0 15px" }}>
                                            <h5>No results available.</h5>
                                        </div>
                                    )}

                                    
                                </List>
                            </Paper>
                       )}
                       <br/>
                        <br/>
                        <br/>
                         <br/>
                        <br/>
                        <br/>
                  </div>
                )}
  
            </div>
            <TabStrip activeTab={2} />
        </div>
    );
  }

};



const mapDispatchToProps = (dispatch) => {
  return {
    updateTab: () => {
      dispatch(changeTab("1"))
    },
    logUserSearch: (sctp, term) => {
        dispatch(logUserSearch(sctp, term));
    }
  }
}


const mapStateToProps = (state) => ({
    member: state.thisApp.auth.member
})


export default connect(
    mapStateToProps,
  mapDispatchToProps
)(SearchPage)




// WEBPACK FOOTER //
// ./src/Pages/Search.js